import { EventSourcePolyfill } from "event-source-polyfill";

// New InstantEvents client, powered by Server Sent Events.
class InstantEvents {
	// Public
	static start({
		EventSource = InstantEvents._eventSourceFactory(),
		eventSourceURL = InstantEvents._eventSourceURL,
		eventOriginsWhitelist = InstantEvents._eventOriginsWhitelist,
		onMessage = InstantEvents._onMessage,
		onOpen = InstantEvents._onOpen,
		onError = InstantEvents._onError,
	} = {}) {
		// Fail silently if already listening.
		if (this._isListening) {
			return;
		}

		// Update the event origin whitelist.
		this._eventOriginsWhitelist = eventOriginsWhitelist;

		// Create an event source with event listeners.
		this._eventSource = new EventSource(eventSourceURL, { withCredentials: true });
		this._eventSource.addEventListener("open", onOpen, false);
		this._eventSource.addEventListener("message", (event) => {
			const data = InstantEvents._parseEventData(event);

			onMessage(data);
		}, false);
		this._eventSource.addEventListener("error", onError, false);
		this._isListening = true;
	}

	static stop() {
		// Fail silently if already not listening.
		if (!this._isListening) {
			return;
		}

		this._eventSource.close();
		this._eventSource = null;
		this._isListening = false;
	}

	// Private
	static get _isSupported() {
		return !!window.EventSource && !!window.EventTarget;
	}
	static _isListening = false;
	static _eventOriginsWhitelist = [
		window.location.origin,
	];
	static _eventSourceURL = "/instantevents";
	static _eventSource = null;

	static _eventSourceFactory() {
		// Validate SSE are supported. If not, use polyfill.
		if (!InstantEvents._isSupported) {
			console.info("Instant Events are unsupported on this browser. Using Polyfill...");
			return EventSourcePolyfill;
		}

		return window.EventSource;
	}

	static _parseEventData(event) {
		console.log("Received Raw Event Data: ", event.data);

		// Ensure same-origin.
		if (this._eventOriginsWhitelist.indexOf(event.origin) === -1) {
			throw new Error(`Instant Event received from unknown origin: ${event.origin}`);
		}

		return JSON.parse(event.data);
	}

	static _onOpen(event) {
		console.info("Connection Opened: ", event);
	}

	static _onMessage(data) {
		console.log("Parsed Event Data: ", data);
	}

	static _onError(event) {
		console.error("Received Error: ", event);

		// Connection closed, but don't worry, it should repopen
		// automagically. Browser will default to retry connection
		// in 3s, unless otherwise specified by the server.
		if (event.readyState === EventSource.CLOSED) {
			console.error("Connection Closed.");
		}
	}
}

// Expose this to the window for debugging.
window.SSIE = InstantEvents;

export default InstantEvents;



// WEBPACK FOOTER //
// ./src/shared/util/InstantEvents.SSE.js